import {
  ChangeDetectionStrategy,
  Component,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { Store } from '@ngrx/store';
import * as FileSaver from 'file-saver';
import { Observable, Subscription } from 'rxjs';

import { ContentDocumentLink } from 'src/app/models/content-document-link.model';
import { Payment } from 'src/app/models/payment.model';
import { AttachmentService, FileAPI } from 'src/app/core/services/attachment';
import * as fromStore from 'src/app/store/';

@Component({
  selector: 'app-billing-page',
  templateUrl: './billing-page.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class BillingPageComponent implements OnInit, OnDestroy {
  subscription: Subscription;

  browserSize$: Observable<string> = this.store.select(
    fromStore.getBrowserSizeName,
  );

  browserSize: string;

  fileSubscription: Subscription;

  payments$: Observable<Payment[]> = this.store.select(
    fromStore.getAllPayments,
  );

  isPaymentsLoading$: Observable<boolean> = this.store.select(
    fromStore.getPaymentsLoading,
  );

  isPaymentsLoaded$: Observable<boolean> = this.store.select(
    fromStore.getPaymentsLoaded,
  );

  invoices$: Observable<ContentDocumentLink[]> = this.store.select(
    fromStore.getAllInvoiceAttachments,
  );

  isInvoicesLoading$: Observable<boolean> = this.store.select(
    fromStore.getInvoiceAttachmentsLoading,
  );

  isInvoicesLoaded$: Observable<boolean> = this.store.select(
    fromStore.getInvoiceAttachmentsLoaded,
  );

  selectedInvoice$: Observable<ContentDocumentLink> = this.store.select(
    fromStore.getSelectedInvoiceAttachment,
  );

  selectedInvoiceFilter$ = this.store.select(
    fromStore.getInvoiceAttachmentFilterNumber,
  );

  selectedPaymentFilter$ = this.store.select(fromStore.getPaymentsFilterNumber);

  constructor(
    private store: Store<fromStore.State>,
    protected attachmentService: AttachmentService,
  ) {
    this.subscription = this.browserSize$.subscribe((name) => {
      if (name) {
        this.browserSize = name;
      }
    });
  }

  ngOnInit(): void {
    this.subscription = this.invoices$.subscribe((data) => {
      if (data.length > 0) {
        this.onSelectInvoice(data[0]);
      }
    });
  }

  ngOnDestroy(): void {
    this.fileSubscription?.unsubscribe();
    this.subscription?.unsubscribe();
  }

  onSelectInvoice(invoice: ContentDocumentLink): void {
    this.store.dispatch(new fromStore.SetSelectedInvoiceAttachment(invoice));
  }

  getInvoiceFileAPIData(file: ContentDocumentLink): Observable<FileAPI> {
    const fileAPIData$: Observable<FileAPI> =
      this.attachmentService.getInvoiceBlob(file);
    return fileAPIData$;
  }

  downloadFile(file: ContentDocumentLink): void {
    let fileData: FileAPI = null;
    const fileAPIData$ = this.getInvoiceFileAPIData(file);
    this.fileSubscription = fileAPIData$.subscribe((data) => {
      fileData = data;
      const newBlob = new Blob([fileData.binaryData], {
        type: `application/${file.ContentDocument.FileExtension}`,
      });
      return FileSaver.saveAs(
        newBlob,
        `${file.ContentDocument.Title}.${file.ContentDocument.FileExtension}`,
      );
    });
  }

  changePaymentFilterSelection(size: number): void {
    this.store.dispatch(new fromStore.SetPaymentsFilterNumber(size));
  }

  changeInvoiceFilterSelection(size: number): void {
    this.store.dispatch(new fromStore.SetInvoiceFilterNumber(size));
  }
}
